import { isDefined, isNotDefined, getRandomFromList, basicTypes, isValidEmail, isInteger, typeOf } from '@togglecorp/fujs';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

var RavlError = (function (_super) {
    __extends(RavlError, _super);
    function RavlError(description, context) {
        var _this = _super.call(this, "\ndescription: " + description + "\ncontext: " + (context || 'n/a')) || this;
        Object.setPrototypeOf(_this, RavlError.prototype);
        _this.description = description;
        _this.context = context;
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return RavlError;
}(Error));

function isExtensionSchema(schema) {
    return schema.extends !== undefined;
}
function isFieldArray(field) {
    return field.arrayType !== undefined;
}
function merge(foo, bar) {
    if (isNotDefined(foo)) {
        return bar;
    }
    else if (isNotDefined(bar)) {
        return foo;
    }
    return __assign({}, foo, bar);
}
var ARRAY = 'array';
var ARRAY_SUFFIXED = 'array.';
var TAB = '    ';
var Dict = (function () {
    function Dict(config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        this.has = function (type) { return isDefined(_this.schemata[type]); };
        this.put = function (type, schema) {
            if (_this.has(type) && _this.config.warning) {
                console.warn("Warning: Overriding schema for key '" + type + "'");
            }
            if (isExtensionSchema(schema) && !_this.schemata[schema.extends]) {
                throw new RavlError("Subtype '" + schema.extends + "' not found");
            }
            _this.schemata[type] = schema;
        };
        this.get = function (type) {
            var result;
            if (typeof type === 'string') {
                if (!_this.has(type)) {
                    throw new RavlError("Key '" + type + "' not found");
                }
                result = _this.schemata[type];
            }
            else {
                result = type;
            }
            if (!isExtensionSchema(result)) {
                return result;
            }
            var subResult = _this.get(result.extends);
            if (isNotDefined(subResult)) {
                throw new RavlError("Subtype '" + result.extends + "' not found");
            }
            return {
                doc: __assign({}, subResult.doc, result.doc),
                fields: merge(subResult.fields, result.fields),
                validator: result.validator || subResult.validator,
            };
        };
        this.list = function () {
            return Object.keys(_this.schemata);
        };
        this.validateField = function (subObject, fieldName, field, context) {
            var isSubObjectFalsy = isNotDefined(subObject);
            if (!isSubObjectFalsy) {
                if (isFieldArray(field)) {
                    _this.validate(subObject, field.arrayType, true, context + " > " + fieldName);
                }
                else {
                    _this.validate(subObject, field.type, false, context + " > " + fieldName);
                }
            }
            else if (field.required) {
                throw new RavlError("Field '" + fieldName + "' is required", context);
            }
        };
        this.validate = function (obj, type, forceArrayCheck, myContext) {
            var context = Dict.getContext(myContext, type);
            if (isNotDefined(obj)) {
                throw new RavlError("Value must be defined", context);
            }
            if (forceArrayCheck || Dict.isString(type) && Dict.isTypeForArray(type)) {
                var objArr = obj;
                _this.validate(obj, ARRAY, false, context);
                var subType_1 = Dict.isString(type) && Dict.isTypeForArray(type)
                    ? type.substring(ARRAY_SUFFIXED.length, type.length)
                    : type;
                objArr.forEach(function (subObject, index) {
                    _this.validate(subObject, subType_1, false, context + " > " + index);
                });
                return;
            }
            var schema = _this.get(type);
            var fields = schema.fields, validator = schema.validator;
            if (isDefined(fields)) {
                var objObj_1 = obj;
                Object.entries(fields).forEach(function (_a) {
                    var _b = __read(_a, 2), fieldName = _b[0], field = _b[1];
                    if (fieldName !== '*') {
                        _this.validateField(objObj_1[fieldName], fieldName, field, context);
                    }
                });
                var extraFields = Object.entries(objObj_1).filter(function (_a) {
                    var _b = __read(_a, 1), fieldName = _b[0];
                    return isNotDefined(fields[fieldName]);
                });
                if (extraFields.length > 0) {
                    if (isDefined(fields['*'])) {
                        extraFields.forEach(function (_a) {
                            var _b = __read(_a, 2), fieldName = _b[0], subObject = _b[1];
                            var field = fields['*'];
                            _this.validateField(subObject, fieldName, field, context);
                        });
                    }
                    else if (_this.config.warning) {
                        var extraFieldNames = extraFields.map(function (_a) {
                            var _b = __read(_a, 1), fieldName = _b[0];
                            return fieldName;
                        });
                        console.warn("Warning: Extra field" + (extraFields.length > 1 ? 's' : '') + " present: '" + extraFieldNames + "'\nContext: " + context);
                    }
                }
            }
            if (isDefined(validator)) {
                validator(obj, context);
            }
        };
        this.getSchema = function (type, level, forceArrayCheck) {
            if (level === void 0) { level = 0; }
            if (forceArrayCheck === void 0) { forceArrayCheck = false; }
            var tabLevel = TAB.repeat(level);
            var tabLevel1 = TAB.repeat(level + 1);
            if (forceArrayCheck || Dict.isString(type) && Dict.isTypeForArray(type)) {
                var subType = Dict.isString(type) && Dict.isTypeForArray(type)
                    ? type.substring(ARRAY_SUFFIXED.length, type.length)
                    : type;
                var schemaForSubType = _this.getSchema(subType, level + 1);
                if (isNotDefined(schemaForSubType)) {
                    schemaForSubType = tabLevel1 + "'" + subType + "',";
                }
                return tabLevel + "[\n" + schemaForSubType + "\n" + tabLevel + "]";
            }
            var schema = _this.get(type);
            if (isNotDefined(schema.fields)) {
                return undefined;
            }
            var doc = tabLevel + "{";
            Object.entries(schema.fields).forEach(function (_a) {
                var _b = __read(_a, 2), fieldName = _b[0], field = _b[1];
                var fieldType;
                var schemaForField;
                if (isFieldArray(field)) {
                    fieldType = field.arrayType;
                    schemaForField = _this.getSchema(fieldType, level + 1, true);
                }
                else {
                    fieldType = field.type;
                    schemaForField = _this.getSchema(fieldType, level + 1, false);
                }
                if (isNotDefined(schemaForField)) {
                    schemaForField = " '" + fieldType + "'";
                }
                else {
                    schemaForField = "\n" + schemaForField;
                }
                doc += "\n" + tabLevel1 + fieldName + ":" + schemaForField + "," + (field.required ? TAB + "// required" : '');
            });
            return doc + "\n" + tabLevel + "}";
        };
        this.getExample = function (type, exampleCount, randomize, forceArrayCheck) {
            if (exampleCount === void 0) { exampleCount = 1; }
            if (randomize === void 0) { randomize = false; }
            if (forceArrayCheck === void 0) { forceArrayCheck = false; }
            if (forceArrayCheck || Dict.isString(type) && Dict.isTypeForArray(type)) {
                var subType = Dict.isString(type) && Dict.isTypeForArray(type)
                    ? type.substring(ARRAY_SUFFIXED.length, type.length)
                    : type;
                var opArray = [];
                var count = (randomize ? Math.floor(Math.random()) : 1) * exampleCount;
                for (var i = 0; i < count; i += 1) {
                    opArray.push(_this.getExample(subType));
                }
                return opArray;
            }
            var schema = _this.get(type);
            if (isNotDefined(schema)) {
                throw new RavlError("'" + type + "' type is not defined");
            }
            var fields = schema.fields, _a = schema.doc.example, example = _a === void 0 ? [] : _a;
            if (isNotDefined(fields)) {
                return randomize
                    ? getRandomFromList(example)
                    : example[0];
            }
            var result = {};
            Object.keys(fields).forEach(function (fieldName) {
                var field = fields[fieldName];
                if (!isNotDefined(field.required) || Math.random() > 0.1) {
                    var valueForField = void 0;
                    if (isFieldArray(field)) {
                        valueForField = _this.getExample(field.arrayType, 1, false, true);
                    }
                    else {
                        valueForField = _this.getExample(field.type, 1, false, false);
                    }
                    result[fieldName] = valueForField;
                }
            });
            return result;
        };
        this.schemata = {};
        this.config = config;
    }
    Dict.isString = function (type) { return (typeof type === 'string'); };
    Dict.isTypeForArray = function (type) { return (type.startsWith(ARRAY_SUFFIXED)); };
    Dict.getContext = function (myContext, type) {
        if (myContext) {
            return myContext;
        }
        if (Dict.isString(type)) {
            return type;
        }
        return 'unknown';
    };
    return Dict;
}());

var examples = {
    boolean: [
        true, false,
    ],
    number: [
        1, 3, 4, 5, 6, 0, -1, -2, -3, -4, -10, -11, -10.12, 11.2121, 1298.432,
        432.342, -23819.12, 3213, 23.21,
    ],
    string: [
        'ram', 'shyam', 'hari', 'home', 'city', 'long text', 'ankit',
        'placeholder',
    ],
    email: [
        'johndoe@email.com', 'hariprasad@emailer.com', 'frozenhelium@toggle.com',
        'doe.john@email.com', 'ramprasad1212@emailer.com', 'fruity1994@toggle.com',
    ],
    int: [
        1, 2, 10, -12, 11, 0,
        -3, 6, 7, -15, 14, -7,
    ],
    uint: [
        1, 2, 10, 11, 0,
        6, 7, 16, 13, 5,
    ],
    unknown: [],
};
var entries = basicTypes.map(function (basicType) {
    var type = basicType.toLowerCase();
    var schema = {
        doc: {
            name: type,
            description: "Basic " + type,
            example: examples[type],
        },
        validator: function (self, context) {
            var identifiedType = typeOf(self);
            if (identifiedType !== type) {
                console.warn(type, identifiedType);
                throw new RavlError("Value must be of type '" + type + "'", context);
            }
        },
    };
    return schema;
});
entries.push({
    doc: {
        name: 'unknown',
        description: 'Unknown',
        example: examples.unknown,
    },
    validator: function () { },
});
entries.push({
    doc: {
        name: 'email',
        description: 'Email',
        example: examples.email,
    },
    validator: function (self, context) {
        if (typeof self !== 'string' || !isValidEmail(self)) {
            throw new RavlError('Value is not a valid email', context);
        }
    },
});
entries.push({
    doc: {
        name: 'int',
        description: 'Integer',
        example: examples.int,
    },
    validator: function (self, context) {
        if (!isInteger(self)) {
            throw new RavlError('Value is not a valid integer', context);
        }
    },
});
entries.push({
    doc: {
        name: 'uint',
        description: 'Unsigned Integer',
        example: examples.uint,
    },
    validator: function (self, context) {
        if (!isInteger(self) || self < 0) {
            throw new RavlError('Value is not a valid unsigned integer', context);
        }
    },
});

export default Dict;
export { RavlError, entries as basicTypes, isExtensionSchema, isFieldArray };
